export  const saveLocation = (ubicacion, nombreUbicacion) => {
    try {
      localStorage.setItem('coordenadasStorage', JSON.stringify(ubicacion));
      localStorage.setItem('municipioStorage', nombreUbicacion);
    } catch (error) {
      console.log(error);
    }
  };